import { useState } from "react";
import { EditableTable } from "@/components/EditableTable";
import { sizesFor } from "@/components/FinishSize";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function PressSwitch({ cfg, readOnly, put }) {
  const [v, setV] = useState(cfg.quote_settings?.calendar_switch_qty ?? "");
  return (
    <div className="flex flex-wrap items-end gap-3 px-5 pt-4" data-testid="calendar-press-switch">
      <label className="text-sm"><span className="block font-medium text-slate-700">Switch to offset at quantity</span>
        <Input type="number" min="1" className="mt-1 w-40" disabled={readOnly} data-testid="calendar-switch-qty-input" value={v} onChange={(e) => setV(e.target.value)} placeholder="Off" /></label>
      {!readOnly && <Button size="sm" data-testid="calendar-switch-qty-save" onClick={() => put("quote_settings", { ...(cfg.quote_settings || {}), calendar_switch_qty: v === "" ? null : Number(v) })}>Save</Button>}
      <p className="w-full text-xs text-slate-500">Calendar quotes below this quantity are priced on the digital press, at or above it on offset, with each press&apos;s own rates from Machine rates. Leave blank to keep the line you pick.</p>
    </div>
  );
}

const T = (key, label, extra = {}) => ({ key, label, ...extra });
const N = (key, label) => T(key, label, { type: "number" });
const SIZES = sizesFor("offset");
const BINDINGS = ["", "wire_o", "spiral", "comb", "perfect", "saddle_stitch"];

/** Admin-managed Calendar Types library: allowed sizes, print model, default finishing workflow and material suggestions. */
export function CalendarTypes({ cfg, readOnly, put }) {
  const subs = (cfg.materials || []).filter((m) => m.category === "substrate" && ((m.service_lines || []).includes("offset") || (m.service_lines || []).includes("digital")));
  const mat = { type: "select", options: ["", ...subs.map((m) => m.code)], labelOf: (c) => subs.find((m) => m.code === c)?.name || c || "None", width: 200 };
  const ops = cfg.finishing_ops || [];
  return (
    <>
      <PressSwitch cfg={cfg} readOnly={readOnly} put={put} />
      <p className="px-5 pt-4 text-xs text-slate-500" data-testid="calendar-types-note">Each calendar type sets the finish sizes offered on quotes, manual jobs and walk-ins, the default print sides (colours front / back), leaves, panels or pages, binding,
        finishing workflow (from the Finishing library) and the suggested inner, cover and base materials. Every default can be changed on the line.</p>
      <EditableTable testId="cfg-calendar-types" readOnly={readOnly} rows={cfg.calendar_types || []} onSave={(v) => put("calendar_types", v.filter((r) => r.code))}
        columns={[T("name", "Calendar type", { width: 170 }),
          T("sizes", "Allowed finish sizes", { type: "multi", options: SIZES.map((s) => s[0]), labelOf: (k) => SIZES.find((s) => s[0] === k)?.[1] || k, width: 260 }),
          N("colors_front", "Colours front"), N("colors_back", "Colours back"),
          T("count_field", "Count field", { type: "select", options: ["", "leaves", "panels", "page_count"], width: 120 }), N("count_default", "Default count"),
          T("binding", "Default binding", { type: "select", options: BINDINGS, width: 130 }),
          T("finishing_ops", "Default finishing workflow", { type: "multi", options: ops.map((o) => o.code), labelOf: (c) => ops.find((o) => o.code === c)?.name || c, width: 280 }),
          T("inner_material", "Inner / sheet material", mat), T("cover_material", "Cover material", mat), T("base_material", "Base / backboard material", mat)]} />
    </>
  );
}
